import React from "react";

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString() + " " + d.toLocaleTimeString();
  } catch (e) {
    return iso;
  }
};
const BlogTable = ({ blogs, isLoading, onEdit, onDelete }) => {
  return (
    <div className="overflow-x-auto">
      {isLoading ? <div className="p-6">Loading...</div> : null}
      <table className="w-full border-separate text-xs md:text-sm border-spacing-0">
        <thead>
          <tr>
            <th className="border-b border-gray-200 px-2 py-2 text-left font-semibold text-gray-500">Image</th>
            <th className="border-b border-gray-200 px-2 py-2 text-left font-semibold text-gray-500">Name</th>
            <th className="border-b border-gray-200 px-2 py-2 text-left font-semibold text-gray-500">Category</th>
            <th className="border-b border-gray-200 px-2 py-2 text-left font-semibold text-gray-500">Created</th>
            <th className="border-b border-gray-200 px-2 py-2 text-right font-semibold text-gray-500">Actions</th>
          </tr>
        </thead>
        <tbody>
          {!isLoading && blogs.length === 0 ? (
            <tr>
              <td colSpan={5} className="p-4 text-center text-xs md:text-sm text-gray-500">No blogs yet</td>
            </tr>
          ) : (
            blogs.map((b) => (
              <tr key={b.id}>
                <td className="border-b border-gray-100 px-2 py-2">
                  {b.image ? (
                    <img src={b.image} alt="" className="h-12 w-12 rounded-lg border border-gray-200 object-contain" />
                  ) : (
                    <div className="flex h-12 w-12 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-xs text-gray-400">—</div>
                  )}
                </td>
                <td className="border-b border-gray-100 px-2 py-2 text-xs md:text-sm">{b.title}</td>
                <td className="border-b border-gray-100 px-2 py-2 text-xs md:text-sm">{b.category || "—"}</td>
                <td className="border-b border-gray-100 px-2 py-2 text-xs md:text-sm">{formatDate(b.created_at)}</td>
                <td className="border-b border-gray-100 px-2 py-2 text-right text-xs md:text-sm">
                  <div className="inline-flex gap-2">
                    <button
                      type="button"
                      onClick={() => onEdit(b)}
                      className="cursor-pointer text-xs md:text-sm rounded-md border border-gray-300 bg-white px-2 py-1"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      onClick={() => onDelete(b.id)}
                      className="cursor-pointer rounded-md border text-xs md:text-sm border-red-500 bg-red-50 px-2 py-1 text-red-700"
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BlogTable;


